import CheckIcon from '@/components/Icons/CheckIcon';
import { useState, type FC } from 'react';

interface Props {
  amenities: string[] | undefined;
}

const PropertyCardFeatures: FC<Props> = ({ amenities }) => {
  const [open, setOpen] = useState(false);

  if (!amenities || amenities.length === 0) {
    return <div className="mb-4 h-6" />;
  }

  return (
    <>
      <button
        onClick={() => setOpen((prevValue) => !prevValue)}
        className="text-accent-600 font-medium hover:text-accent-700 mb-4 flex items-center"
      >
        {open ? 'Hide' : 'View'} Features
        <svg
          className={`w-5 h-5 ml-1 transition-transform ${open ? 'rotate-180' : ''}`}
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7" />
        </svg>
      </button>

      {open ? (
        <div className="mb-4 p-4 bg-gray-50 rounded-none">
          <h4 className="font-semibold text-gray-900 mb-2">Features:</h4>
          <ul className="space-y-1">
            {amenities.map((feature) => (
              <li
                key={`property-feature-${feature}`}
                className="text-sm text-gray-600 flex items-center"
              >
                <CheckIcon />
                {feature}
              </li>
            ))}
          </ul>
        </div>
      ) : null}
    </>
  );
};

export default PropertyCardFeatures;
